import { render } from "./AdvancedSettingsGEN2.vue?vue&type=template&id=04c19f29&ts=true"
import script from "./AdvancedSettingsGEN2.vue?vue&type=script&lang=ts"
export * from "./AdvancedSettingsGEN2.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__